import { mediaQuery, slideDown, slideUp } from '~/js/helpers';

const body = document.body;
const toggleButton = document.querySelectorAll('.offcanvas-toggler');
const offCanvasAll = document.querySelectorAll('.offcanvas');

toggleButton.forEach((button) => {
	const offCanvas = document.querySelector('[data-toggler="' + button.dataset.toggle + '"]');

	if (!mediaQuery('xl')) {
		offCanvas.classList.remove('hidden');
	}

	button.addEventListener('click', () => {
		const isOpening = !offCanvas.hasAttribute('data-open');
		toggleOffCanvas(offCanvas, toggleButton);
		body.classList.toggle('offcanvas-open');
		if ('mobile-menu' === button.dataset.toggle) {
			window.scrollTo(0, 0);
		}
		if (offCanvas.dataset.overlay) {
			body.classList.toggle('offcanvas-overlay');
		}
		toggleOffCanvasTabbing();

		// Automatically open the first submenu when offcanvas opens
		if (isOpening) {
			const path = window.location.pathname || '';
			const isClientsUrl = (path === strl_vars.clients || path.startsWith(strl_vars.clients + '/'));
			let currentPersona = localStorage.getItem('yer_persona') || 'candidate';
			if (isClientsUrl) {
				currentPersona = 'client';
			}

			const currentMenu = offCanvas.querySelector('[data-main-' + currentPersona + ']');
			const subMenuParent = currentMenu.querySelectorAll('.menu-item-has-children');
			if (subMenuParent.length > 0) {
				const firstSubMenu = subMenuParent[0].querySelector('.sub-menu');
				if (firstSubMenu && !firstSubMenu.checkVisibility()) {
					toggleMobileSubmenu(subMenuParent[0]);
				}
			}
		}
	});
});

offCanvasAll.forEach((offCanvas) => {
	offCanvas.querySelectorAll('.sub-menu').forEach((subMenu) => {
		subMenu.classList.add('hidden');
	});

	const subMenuParent = offCanvas.querySelectorAll('.menu-item-has-children');
	const dropdownIcons = offCanvas.querySelectorAll('[data-menu-dropdown-icon]');

	dropdownIcons.forEach((icon) => icon.setAttribute('tabindex', '-1'));

	subMenuParent.forEach((parent) => {
		const dropdownIcon = parent.querySelector('[data-menu-dropdown-icon]');
		if (!dropdownIcon) {
			return;
		}

		dropdownIcon.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			toggleMobileSubmenu(parent);
		});

		dropdownIcon.addEventListener('keyup', (e) => {
			if ('Enter' === e.key) {
				e.preventDefault();
				toggleMobileSubmenu(parent);
			}
		});

		// Toggle submenu when link has no href or empty href with hashtag
		const parentLink = parent.querySelector('a');
		if (parentLink) {
			const href = parentLink.getAttribute('href');
			if (!href || '#' === href) {
				parentLink.addEventListener('click', (e) => {
					e.preventDefault();
					toggleMobileSubmenu(parent);
				});
			}
		}
	});

	// Close submenu's on Esc
	document.addEventListener('keyup', (e) => {
		if ('Escape' === e.key && body.classList.contains('offcanvas-open') && offCanvas.hasAttribute('data-open')) {
			toggleOffCanvas(offCanvas, toggleButton);
			body.classList.remove('offcanvas-open');
			toggleOffCanvasTabbing();
		}
	});

	// Close submenu when focus out of last VISIBLE menu item
	let currFocus = document;
	document.addEventListener('keyup', (e) => {
		if ('Tab' === e.key && body.classList.contains('offcanvas-open')) {
			const canvasItems = offCanvas.querySelectorAll('a, button, [tabindex]');
			const visibleItems = [];
			canvasItems.forEach((item) => {
				if (item.checkVisibility()) {
					visibleItems.push(item);
				}
			});

			if (visibleItems.length && currFocus === visibleItems[visibleItems.length - 1]) {
				toggleOffCanvas(offCanvas, toggleButton);
				body.classList.remove('offcanvas-open');
				toggleOffCanvasTabbing();
			}
			currFocus = e.target;
		}
	});
});

toggleOffCanvasTabbing();

// FacetWP tabindex can only be changed with an action
document.addEventListener('facetwp-loaded', () => {
	if ('undefined' !== typeof FWP.hooks) {
		FWP.hooks.addAction(
			'facetwp/loaded',
			function () {
				toggleOffCanvasTabbing();
			},
			1000
		);
	}
});

function toggleOffCanvasTabbing() {
	const links = document.querySelectorAll(
		'.offcanvas button:not([data-filter-group-title],[data-reset-filter],.locate-me), .offcanvas a, .offcanvas [data-menu-dropdown-icon], .offcanvas [tabindex]'
	);
	links.forEach((link) => {
		if (!document.body.classList.contains('offcanvas-open')) {
			link.setAttribute('tabindex', '-1');
		} else {
			link.setAttribute('tabindex', '0');
		}
	});
}

function toggleMobileSubmenu(parent) {
	const subMenu = parent.querySelector('.sub-menu');
	const dropdownIcon = parent.querySelector('[data-menu-dropdown-icon]');
	const isClosed = subMenu.classList.contains('hidden');

	if (isClosed) {
		slideDown(subMenu);
		dropdownIcon.classList.add('rotate-180');
		window.setTimeout(() => {
			subMenu.classList.remove('hidden');
		}, 300);
	} else {
		slideUp(subMenu);
		dropdownIcon.classList.remove('rotate-180');
		window.setTimeout(() => {
			subMenu.classList.add('hidden');
		}, 300);
	}
}

function toggleOffCanvas(offCanvas, toggleButton) {
	const toggleClasses = ['translate-x-full', 'translate-x-0', 'pointer-events-none', 'pointer-events-auto'];
	toggleClasses.map((list) => offCanvas.classList.toggle(list));
	toggleButton.forEach((button) => {
		button.querySelectorAll('.open-button').forEach((el) => el.classList.toggle('hidden!'));
		button.querySelectorAll('.close-button').forEach((el) => el.classList.toggle('hidden!'));
	});
	offCanvas.toggleAttribute('data-open');
	document.body.classList.toggle('overflow-hidden');
}
